import RecommendList from './recommend-list'
export default RecommendList